<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">

      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <!-- <div class="col-3">
        <mat-label>Select Booth</mat-label>
      
        <mat-select [(ngModel)]="selectedOption" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option *ngFor="let option of businessGroups" [value]="option.id">{{ option.name }}</mat-option>
        </mat-select>

       
      </div> -->
      <div class="col-3">
        <mat-label>Select Booth &nbsp; <mat-checkbox (change)="checkboxChanged($event)" checked="true">All</mat-checkbox> </mat-label>
        <mat-select multiple style="border-radius: 10px; border: 1px solid black; padding: 17px;"
          [(ngModel)]="selectedOption" [disabled]="route_disabled" (ngModelChange)="changeEvent()">
          <mat-option *ngFor="let option of businessGroups" [value]="option.id">{{ option.name }}</mat-option>
        </mat-select>
      </div>

      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="from_date == null || to_date == null || selectedOption ==null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i
            class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div>

  </div>


</section>